import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
// import PropTypes from 'prop-types';

import { CommandFactory } from '../../background/commands/CommandFactory';
import LoadSpinner from '../primitives/LoadSpinner';

import ExplorePageUsersList from './ExplorePageUsersList';
import { SendEventToGoogleAnalytics } from '../../background/storeListener/googleAnalyticsListener';


const ExplorePageMostCopied = ({ location, handleItemSelect, limit, toggleOpenCopyTab, copyColor }) => {
    const [orderedTopTraders, setOrderedTopTraders] = useState([]);
    const [orderedTopThreeTraders, setOrderedTopThreeTraders] = useState([]);
    const [, setResponse] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { getMostCopied } = useSelector((state) => { return (state.account.socialv1.exploreCommands); }, shallowEqual);

    const handleUserSelect = (data)=>{
      handleItemSelect(data, "MostCopied");
    }

    const getMostCopiedUsers = async () => {

        const command = CommandFactory.createCommand(getMostCopied);
        setIsLoading(true);

        try {
            setResponse(null);
            const res = await command.execute({ limit });

            if (res.isSuccessful === true) {
                setOrderedTopThreeTraders(res.payload.slice(0, 3));
                setOrderedTopTraders(res.payload.slice(3, limit));
            } else if (res.isSuccessful === false) {
                setResponse(res);
            }
        } catch (err) {
            setResponse(err);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        getMostCopiedUsers();
        SendEventToGoogleAnalytics("Explore:MostCopiedTabOpened")
    }, []);

    return (
        isLoading ? (
            <LoadSpinner />
        ) : (
            <ExplorePageUsersList
            location={location}
                users={orderedTopTraders}
                topThreeUsers={orderedTopThreeTraders}
                handleItemSelect={handleUserSelect}
                toggleOpenCopyTab={toggleOpenCopyTab}
                copyColor={copyColor}
            />
        )
    );
};

// ExplorePageMostCopied.propTypes = {};

export default ExplorePageMostCopied;
